import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { RESUME_URL } from "../lib/data";
import { Download } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Experience", href: "#experience" },
  { label: "Projects", href: "#projects" },
  { label: "Skills", href: "#skills" },
  { label: "Contact", href: "#contact" },
];

export const HeaderNav = ({ overDark = false }) => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Light text only when over a dark hero AND not yet scrolled into the glass bar.
  const light = overDark && !scrolled;
  const logoColor = light ? "text-white" : "text-foreground";
  const linkColor = light ? "text-white/80 hover:text-white" : "text-foreground/70 hover:text-primary";

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,box-shadow] duration-300 ${
        scrolled ? "bg-white/80 backdrop-blur-xl border-b border-black/5" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className={`font-serif text-lg tracking-tight ${logoColor}`}>
          Vatushi<span className="text-primary">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {onHome ? (
            links.map((l) => (
              <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase()}`}
                className={`text-sm transition-colors duration-200 ${linkColor}`}>
                {l.label}
              </a>
            ))
          ) : (
            <Link to="/" className={`text-sm transition-colors duration-200 ${linkColor}`}>
              ← Back to portfolio
            </Link>
          )}
        </nav>

        <a href={RESUME_URL} target="_blank" rel="noopener noreferrer" download data-testid="nav-resume-btn"
          className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground text-sm px-4 py-2 hover:bg-[hsl(242,47%,28%)] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2">
          <Download size={15} /> Resume
        </a>
      </div>
    </header>
  );
};
